import {useDayItems} from '../../providers/dayItems/useDayItems.ts'
import {WeekContainer} from './WeekContainer.tsx'
import {Box, Center, Checkbox, Group, InputLabel, SegmentedControl} from '@mantine/core'
import {useLocalSettings} from '../../providers/localSettings/useLocalSettings.ts'
import {ProjectSelect} from './components/ProjectSelect.tsx'
import {useFilters} from './providers/filters/useFilters.ts'
import {DateRangeSelector} from '../../components/dateRangeSelector/DateRangeSelector.tsx'
import {getWeek} from './components/time/getWeek.ts'
import {IconBaselineDensitySmall, IconLayoutList} from '@tabler/icons-react'
import {FilterBar} from '../../components/filterBar/FilterBar.tsx'

export const CalendarContainer = () => {
  const {week, setWeek, projectId, setProjectId} = useFilters()
  const {loading: loadingTimeEntries} = useDayItems()
  const {
    compactMode,
    setCompactMode,
    showWeekend,
    setShowWeekend,
    showRecommendations,
    setShowRecommendations,
    mergeRecommendations,
    setMergeRecommendations,
    roundRecommendationTimes,
    setRoundRecommendationTimes,
  } = useLocalSettings()

  const disabled = loadingTimeEntries

  return (
    <div style={{display: 'flex', flexDirection: 'column', gap: 15}}>
      <FilterBar
        mainControls={<DateRangeSelector range={'week'} value={week} onValueChange={setWeek} disabled={disabled} />}
        secondaryControls={
          <>
            <ProjectSelect value={projectId} onChange={setProjectId} allowArchivedSelection disabled={disabled} />

            <div>
              <InputLabel>Recommendations</InputLabel>
              <Group mt='xs'>
                <Checkbox
                  variant={'outline'}
                  label={'Show'}
                  checked={showRecommendations}
                  onChange={({target: {checked}}) => setShowRecommendations(checked)}
                  disabled={disabled}
                />
                <Checkbox
                  variant={'outline'}
                  label={'Merge overlapping'}
                  checked={mergeRecommendations}
                  onChange={({target: {checked}}) => setMergeRecommendations(checked)}
                  disabled={disabled || !showRecommendations}
                />
                <Checkbox
                  variant={'outline'}
                  label={'Round start/end time'}
                  checked={roundRecommendationTimes}
                  onChange={({target: {checked}}) => setRoundRecommendationTimes(checked)}
                  disabled={disabled || !showRecommendations}
                />
              </Group>
            </div>
            <div>
              <InputLabel>Weekend</InputLabel>
              <Box mt={'sm'}>
                <Checkbox
                  variant={'outline'}
                  label={'Show'}
                  checked={showWeekend}
                  onChange={({target: {checked}}) => setShowWeekend(checked)}
                  disabled={disabled}
                />
              </Box>
            </div>
            <div>
              <Box pb={5}>
                <InputLabel>View mode</InputLabel>
              </Box>
              <SegmentedControl
                size={'sm'}
                value={compactMode ? 'compact' : 'normal'}
                onChange={(value) => setCompactMode(value === 'compact')}
                data={[
                  {
                    label: (
                      <Center>
                        <IconLayoutList stroke={1} size={15} />
                      </Center>
                    ),
                    value: 'normal',
                  },
                  {
                    label: (
                      <Center>
                        <IconBaselineDensitySmall stroke={1} size={15} />
                      </Center>
                    ),
                    value: 'compact',
                  },
                ]}
                disabled={disabled}
              />
            </div>
          </>
        }
      />
      <WeekContainer days={getWeek(week.start, showWeekend)} disabled={disabled} />
    </div>
  )
}
